import { Box } from "@mui/material";
import { ReactComponent as NonIdealIcon } from "./../../../../assets/icons/draft_non_ideal_icon.svg";
import "./styles.css";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const InvoiceBookNonIdeal = ({
  icon = <NonIdealIcon />,
  title = "",
  subTitle = "",
  onBack,
  buttonTitle = 'Back',
  buttonClassName,
  buttonId,
  children,
}) => {



  return (
    <Box className="non-ideal-container">
      {/* I add this class and paragraph because of small resolution */}
      <ParagraphText className="iconWrapper">{icon}</ParagraphText>
      {title && (
        <ParagraphText className="title">{title}</ParagraphText>
      )}
      {subTitle && (
        <ParagraphText className="sub-title">
          {subTitle}
        </ParagraphText>
      )}
      {typeof onBack === "function" && (
        <UBButton
          id={buttonId || "invoice_book_non_ideal_action_btn"}
          title={buttonTitle}
          onClick={() => { triggerLogEvent(analytics, "inv_watch_tutorial"); onBack(); }}
          className={
            buttonClassName ||
            `textUppercase foundationBlueNormalBg foundationWhite fontSize14 marginTop25 marginBottom15`
          }
        />
      )}
      {children}
    </Box>
  );
};
export default InvoiceBookNonIdeal;
